import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule } from '@spartacus/core';
import { GenericLinkModule, MediaModule } from '@spartacus/storefront';
import { UigBannerComponent } from './uig-banner.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        GenericLinkModule,
        MediaModule,
        ConfigModule.withConfig({
            cmsComponents: {
                SimpleBannerComponent: {
                    component: UigBannerComponent,
                },
            }
        } as CmsConfig)
    ],
    declarations: [UigBannerComponent],
    exports: [UigBannerComponent]
})
  export class UigBannerModule {}